// import React, { useEffect } from "react";
// import "./Banner.css";
// import "swiper/css/pagination";

// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Pagination } from "swiper/modules";
// import { useDispatch, useSelector } from "react-redux";

// import "swiper/css";
// import { AllBanners } from "../../../features/admin/common/Slice";
// import { IDS } from "../../../utils/IDS";

// const Banner = () => {
//   const dispatch = useDispatch();
//   const all_banner = useSelector((state) => state?.common?.all_banner);
//   console.log(all_banner, "all_bannerall_banner");

//   useEffect(() => {
//     dispatch(AllBanners());
//   }, [dispatch]);

//   return (
//     <div className="Banner_ImageContainer">
//       <div className="overlay"></div>

//       <Swiper
//         modules={[Autoplay, Pagination]}
//         spaceBetween={0}
//         slidesPerView={1}
//         pagination={{ clickable: true }}
//         loop={true}
//         autoplay={{
//           delay: 3000,
//           disableOnInteraction: false,
//         }}
//         className="bannerSwiper"
//       >
//         {all_banner?.length > 0 ? (
//           all_banner
//             .filter((banner) => banner.type === "customer")
//             .map((banner) => (
//               <SwiperSlide key={banner.id}>
//                 <div className="Image">
//                   <div className="img_holder">
//                     <img
//                       src={`${IDS?.IMG_URL}/${banner.image}`}
//                       alt={banner.title}
//                       className="myImage"
//                     />

//                     <div className="banner_content">
//                       <h2>Welcome to Our Website</h2>
//                       <p>Your perfect moments start here</p>

//                     </div>
//                   </div>
//                 </div>
//               </SwiperSlide>
//             ))
//         ) : (
//           <SwiperSlide>
//             <div className="Image">
//               <div className="img_holder">
//                 <img
//                   src="/assets/images/home_banner.png"
//                   alt="Default Banner"
//                   className="myImage"
//                 />
//               </div>
//             </div>
//           </SwiperSlide>
//         )}
//       </Swiper>
//     </div>
//   );
// };

// export default Banner;

import { ShimmerThumbnail } from "react-shimmer-effects";
import React, { useEffect } from "react";
import "./Banner.css";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { useDispatch, useSelector } from "react-redux";
import { AllBanners } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";

const Banner = () => {
  const dispatch = useDispatch();
  const all_banner = useSelector((state) => state?.common?.all_banner);

  useEffect(() => {
    dispatch(AllBanners());
  }, [dispatch]);

  return (
    <div className="Banner_ImageContainer">
      <Swiper
        modules={[Autoplay, Pagination]}
        spaceBetween={0}
        slidesPerView={1}
        pagination={{ clickable: true }}
        loop={true}
        // autoplay={{ delay: 3000, disableOnInteraction: false }}
        className="bannerSwiper"
      >
        {all_banner?.length > 0 ? (
          all_banner
            .filter((banner) => banner.type === "customer")
            .map((banner) => {
              return (
                <SwiperSlide key={banner.id}>
                  <div className="img_holder">
                    <img
                      src={`${IDS?.IMG_URL}/${banner.image}`}
                      alt={banner.title}
                      className="myImage"
                    />

                    <div className="overlay"></div>

                    <div className="banner_content">
                      <h2>{banner?.title}</h2>
                      <p>{banner?.description}</p>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })
        ) : (
          <SwiperSlide>
            <div className="img_holder">
              <ShimmerThumbnail height={700} width="100%" rounded />
            </div>
          </SwiperSlide>
        )}
        {/* <SwiperSlide>
            <div className="img_holder">
              <img
                src="/assets/images/home_banner.png"
                alt="Default Banner"
                className="myImage"
              />
              <div className="overlay"></div>
              <div className="banner_content">
                <h2>Welcome to Our Website</h2>
                <p>Your perfect moments start here</p>
              </div>
            </div>
          </SwiperSlide> */}
      </Swiper>
    </div>
  );
};

export default Banner;
